import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError';
import { MedicalNotesApi } from '../../../apis/MedicalNotesApi/MedicalNotesApi';
import { IMedicalNote } from '../MedicalNote';

export function useUpdateMedicalNoteMutation(patientId?: string) {
    if (!patientId) 
        throw new Error('useUpdateMedicalNoteMutation requires a valid patientId');

    const queryClient = useQueryClient();

    return useMutation<boolean, AppMedError, IMedicalNote, unknown>({
        mutationKey: [QueryKeys.medicalNote, patientId],
        mutationFn: async (variables: IMedicalNote) => {
            return await MedicalNotesApi.updateMedicalNote(patientId, variables);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.medicalNote, patientId] });
        },
    });
}
